import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "size", "strokeWidth", "progress", "barColor", "trackColor", "isDark", "dark", "withNumber", "withPercentage", "htmlProps", "children", "centerColor", "fullInternalWith"];
import { grayDark, secondaryMain, white } from "../styles/colors";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ProgressRing = function ProgressRing(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 80 : _ref$size,
    _ref$strokeWidth = _ref.strokeWidth,
    strokeWidth = _ref$strokeWidth === void 0 ? 8 : _ref$strokeWidth,
    progress = _ref.progress,
    _ref$barColor = _ref.barColor,
    barColor = _ref$barColor === void 0 ? secondaryMain : _ref$barColor,
    trackColorProp = _ref.trackColor,
    isDark = _ref.isDark,
    dark = _ref.dark,
    withNumber = _ref.withNumber,
    withPercentage = _ref.withPercentage,
    htmlProps = _ref.htmlProps,
    children = _ref.children,
    _ref$centerColor = _ref.centerColor,
    centerColor = _ref$centerColor === void 0 ? white : _ref$centerColor,
    fullInternalWith = _ref.fullInternalWith,
    progressRingProps = _objectWithoutProperties(_ref, _excluded);
  var trackColor = trackColorProp || grayDark;
  var radius = size / 2;
  var normalizedRadius = radius - strokeWidth;
  var circumference = normalizedRadius * 2 * Math.PI;
  var strokeDashoffset = circumference - progress / 100 * circumference;
  var strokeDasharray = "".concat(circumference, " ").concat(circumference);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread(_objectSpread({
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    height: size,
    width: size,
    viewBox: "0 0 ".concat(size, " ").concat(size)
  }, htmlProps), progressRingProps), {}, {
    children: [/*#__PURE__*/_jsx("circle", {
      stroke: trackColor,
      fill: "transparent",
      strokeWidth: strokeWidth,
      strokeDasharray: strokeDasharray,
      style: {
        opacity: trackColorProp ? 1 : 0.2
      },
      r: normalizedRadius,
      cx: radius,
      cy: radius
    }), /*#__PURE__*/_jsx("circle", {
      className: "progress-ring--ring",
      stroke: barColor,
      fill: "transparent",
      strokeWidth: fullInternalWith ? strokeWidth : strokeWidth / 2,
      strokeDasharray: strokeDasharray,
      style: {
        strokeDashoffset: strokeDashoffset
      },
      r: normalizedRadius,
      cx: radius,
      cy: radius
    }), centerColor && /*#__PURE__*/_jsx("circle", {
      fill: centerColor,
      r: normalizedRadius - 1,
      cx: radius,
      cy: radius
    }), children, !children && withNumber ? /*#__PURE__*/_jsxs("text", {
      x: radius,
      y: radius,
      fontSize: radius / 2,
      textAnchor: "middle",
      alignmentBaseline: "central",
      className: "font-nun tw-font-semibold fill-current ".concat(isDark || dark ? 'text-white' : 'text-base-main'),
      children: [progress, " ", withPercentage ? '%' : null]
    }) : null]
  }));
};
export default ProgressRing;